import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Tab } from '@feathr/components';

import Page from '../Page';
import FeathrLiteOnboardingCard from './FeathrLiteOnboarding/FeathrLiteOnboardingCard';
import GoalsTwoPointOh from './GoalsTwoPointOh';
import PackageSwitcher from './PackageSwitcher/PackageSwitcher';

function DevelopmentQAPage(): JSX.Element {
  const { t } = useTranslation();
  const [isResetting, setIsResetting] = useState(false);
  const [activeTab, setActiveTab] = useState('goals-v2');

  function handleTabChange(tab: string): void {
    setActiveTab(tab);
  }

  const tabs = [
    <Tab
      active={activeTab === 'package-switcher'}
      key={'package-switcher'}
      onClick={(): void => handleTabChange('package-switcher')}
      title={t('Package Switcher')}
    />,
    <Tab
      active={activeTab === 'goals-v2'}
      key={'goals-v2'}
      onClick={(): void => handleTabChange('goals-v2')}
      title={t('Goals 2.0')}
    />,
    <Tab
      active={activeTab === 'feathr-lite-onboarding'}
      key={'feathr-lite-onboarding'}
      onClick={(): void => handleTabChange('feathr-lite-onboarding')}
      title={t('Feathr Lite Onboarding')}
    />,
  ];

  return (
    <Page tabs={tabs} title={t('Development & QA')}>
      {activeTab === 'package-switcher' && <PackageSwitcher isResetting={isResetting} />}
      {activeTab === 'feathr-lite-onboarding' && (
        <FeathrLiteOnboardingCard isResetting={isResetting} setIsResetting={setIsResetting} />
      )}
      {activeTab === 'goals-v2' && <GoalsTwoPointOh />}
    </Page>
  );
}

export default DevelopmentQAPage;
